import { Card, CardContent, CardHeader, Typography, Stack, Chip, Table, TableHead, TableRow, TableCell, TableBody, Divider } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { integrationApi } from '../../api/integration.api';

export function DocsPage() {
  const { data } = useQuery({ queryKey: ['integration-docs'], queryFn: () => integrationApi.docs() });

  return (
    <>
      <PageHeader title="API Documentation Portal" subtitle="Gateway endpoints, authentication, connectors and webhook reference." />
      {data && (
        <Stack spacing={2}>
          <Card><CardContent><Typography variant="body2">{data.overview}</Typography>
            <Stack direction="row" spacing={0.5} mt={1} flexWrap="wrap" useFlexGap>{data.transports.map((t) => <Chip key={t} size="small" label={t} />)}</Stack>
          </CardContent></Card>

          <Card>
            <CardHeader title="Authentication" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent>
              <Stack spacing={1.5}>
                {data.authentication.map((a) => (
                  <div key={a.method}><Typography variant="subtitle2">{a.method}</Typography><Typography variant="body2" color="text.secondary">{a.how}</Typography></div>
                ))}
              </Stack>
            </CardContent>
          </Card>

          <Card>
            <CardHeader title="Gateway Endpoints" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent sx={{ p: 0, overflowX: 'auto' }}>
              <Table size="small">
                <TableHead><TableRow><TableCell>Method</TableCell><TableCell>Path</TableCell><TableCell>Auth</TableCell><TableCell>Description</TableCell></TableRow></TableHead>
                <TableBody>
                  {data.gateway.map((g) => (
                    <TableRow key={g.path}><TableCell><Chip size="small" label={g.method} /></TableCell><TableCell><code>{g.path}</code></TableCell><TableCell>{g.auth}</TableCell><TableCell>{g.description}</TableCell></TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>

          <Card>
            <CardHeader title="Webhooks" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent>
              <Typography variant="subtitle2">Outgoing</Typography>
              <Typography variant="body2" color="text.secondary">{data.webhooks.outgoing.description}</Typography>
              <Stack direction="row" spacing={0.5} my={1}>{data.webhooks.outgoing.headers.map((h) => <Chip key={h} size="small" variant="outlined" label={h} />)}</Stack>
              <Divider sx={{ my: 1 }} />
              <Typography variant="subtitle2">Retry</Typography>
              <Typography variant="body2" color="text.secondary">{data.webhooks.retry.strategy} — {data.webhooks.retry.formula}. {data.webhooks.retry.deadLetter}.</Typography>
            </CardContent>
          </Card>

          <Card>
            <CardHeader title="Connectors" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent sx={{ p: 0, overflowX: 'auto' }}>
              <Table size="small">
                <TableHead><TableRow><TableCell>Connector</TableCell><TableCell>Category</TableCell><TableCell>Transports</TableCell><TableCell>Auth</TableCell><TableCell>Actions</TableCell></TableRow></TableHead>
                <TableBody>
                  {data.connectors.map((c) => (
                    <TableRow key={c.key}><TableCell>{c.label}</TableCell><TableCell>{c.category.toUpperCase()}</TableCell><TableCell>{c.transports.join(', ')}</TableCell><TableCell>{c.authTypes.join(', ')}</TableCell><TableCell>{c.actions.join(', ') || '—'}</TableCell></TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </Stack>
      )}
    </>
  );
}
